import React from 'react';
import PrimaryButton from '@/components/common/buttons/PrimaryButton';
import { Text, VStack } from '@chakra-ui/react';
import { usePropertyBundles } from '@/hooks/payment/usePropertyBundles';
import { useCreditCheckout } from '@/hooks/payment/useCreditCheckout';
import SavedCardPaymentConfirmationDialog from '@/components/payment/SavedCardPaymentConfirmationDialog.tsx';

/**
 * Component shown when a house requires payment to access
 * Provides options to purchase credits for house access
 */
export const HousePaymentRequired: React.FC = () => {
	const { getOneOffPropertyBundle } = usePropertyBundles();
	const {
		initiateCheckout,
		confirmCheckout,
		cancelCheckout,
		isConfirmationOpen,
		savedCard,
		pendingBundle,
		isProcessingCheckout,
	} = useCreditCheckout();

	const handlePurchaseAccess = () => {
		const bundle = getOneOffPropertyBundle();
		if (bundle) {
			void initiateCheckout(bundle.id);
		}
	};

	return (
		<VStack gap={6} p={8} textAlign="center">
			<Text fontSize="xl" fontWeight="bold">
				House access required
			</Text>
			<Text fontSize="sm" color="fg.muted">
				This house requires payment to access. Purchase access to continue.
			</Text>
			<PrimaryButton
				onClick={handlePurchaseAccess}
				size="lg"
				loading={isProcessingCheckout}
				loadingText="Processing..."
			>
				Purchase access
			</PrimaryButton>

			<SavedCardPaymentConfirmationDialog
				isOpen={isConfirmationOpen}
				amountCents={pendingBundle?.price_amount_cents ?? 0}
				card={savedCard}
				isLoading={isProcessingCheckout}
				onCancel={cancelCheckout}
				onConfirm={confirmCheckout}
			/>
		</VStack>
	);
};
